import React from 'react';
import Grid from '@mui/material/Grid';
import ListItemText from '@mui/material/ListItemText';
import Chip from '@mui/material/Chip';
import { dateToText } from '../../utils/helpers';
import ChipLabel from './chip-label';

const MessageItem = (props) => {
  const { item, idx, seekerId, i18n } = props || {};
  const from =
    seekerId === item.externalFrom ? i18n('Seeker') : i18n('Landlord');

  const alignment = seekerId === item.externalFrom ? 'right' : 'left';
  const timestamp = dateToText(item.createdAt);
  let textArray = [item.text];

  if (/\\n/.test(item.text)) {
    textArray = item.text.split(/\\n/);
  } else {
    textArray = item.text.split(/\n/);
  }

  return (
    <Grid container key={idx}>
      <Grid item xs={12}>
        <ListItemText key={idx}>
          <Chip
            label={
              <ChipLabel
                avatar={from[0].toUpperCase()}
                avatarOrder={alignment}
                textArray={textArray}
                style={{
                  paddingLeft: '4px',
                  paddingRight: '4px'
                }}
              />
            }
            style={{
              display: 'inline-table',
              backgroundColor: alignment === 'left' ? '#2196f3' : '#D3D3D3',
              color: alignment === 'left' ? '#fafafa' : '#000000',
              paddingTop: '8px',
              paddingBottom: '8px'
            }}
            classes={{
              label:
                alignment === 'left'
                  ? 'message-chip-sender'
                  : 'message-chip-reciever'
            }}
          />
        </ListItemText>
      </Grid>
      <Grid item xs={12}>
        <ListItemText secondary={timestamp} />
      </Grid>
    </Grid>
  );
};

export default MessageItem;